import {styled} from '@mui/material';

import {StyledCard} from 'presentation/components/StyledCard';

export const AppointmentCardContainer = styled(StyledCard.Container)`
	height: 100%;
	justify-content: unset;
	min-width: 328px;

	@media (max-width: 320px) {
		min-width: 285px;
	}
`;
